import styles from './add-template-modal.module.css';
import { FormTemplate } from '@employ-engage/data';
import AddTemplateForm from '../add-template-form/add-template-form';
import classNames from 'classnames';
import Modal from '../modal/modal';
import { useTranslation } from 'react-i18next';

export interface AddTemplateModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  templateSelectedForEditing: FormTemplate | null;
  refetchFormTemplates: () => void;
}

export function AddTemplateModal({
  open,
  setOpen,
  templateSelectedForEditing,
  refetchFormTemplates,
}: AddTemplateModalProps) {
  const { t } = useTranslation(['common']);
  return (
    <Modal
      disableCloseOnOutsideClick
      open={open}
      setOpen={setOpen}
      panelClassName={classNames(
        'w-full max-w-[1200px] relative',
        styles['modal-panel']
      )}
    >
      <div>
        <div className="text-2xl font-bold leading-9 text-gray-900">
          {templateSelectedForEditing ? t('Edit Template') : t('Add Template')}
        </div>
      </div>
      <div className="mt-5">
        <AddTemplateForm
          onClose={() => setOpen(false)}
          templateSelectedForEditing={templateSelectedForEditing}
          refetchFormTemplates={refetchFormTemplates}
        />
      </div>
    </Modal>
  );
}

export default AddTemplateModal;
